import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ElementUI from 'element-ui';
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW';
import enLocale from 'element-ui/lib/locale/lang/en';
import viLocale from 'element-ui/lib/locale/lang/vi';
import idLocale from 'element-ui/lib/locale/lang/id';
import jaLocale from 'element-ui/lib/locale/lang/ja';
import kmLocale from 'element-ui/lib/locale/lang/km';
import zhTW from '@/assets/locale/zh-TW.json';
import en from '@/assets/locale/en.json';
import vi from '@/assets/locale/vi.json';
import my from '@/assets/locale/my.json';
import id from '@/assets/locale/id.json';
import ja from '@/assets/locale/ja.json';
import km from '@/assets/locale/km.json';

Vue.use(VueI18n);

const messages = {
  'zh-TW': {
    ...zhTW,
    ...zhTWLocale,
  },
  en: {
    ...en,
    ...enLocale,
  },
  vi: {
    ...vi,
    ...viLocale,
  },
  my: {
    ...my,
    // 緬甸語的 Element UI 翻譯會放在 my.json 的 `el` 命名空間中
  },
  id: {
    ...id,
    ...idLocale,
  },
  ja: {
    ...ja,
    ...jaLocale,
  },
  km: {
    ...km,
    ...kmLocale,
  },
};

// 從 localStorage 取得語言設定，預設為繁體中文
const getDefaultLocale = () => {
  const savedLocale = localStorage.getItem('locale');
  if (savedLocale && messages[savedLocale]) {
    return savedLocale;
  }
  return 'zh-TW';
};

const i18n = new VueI18n({
  locale: getDefaultLocale(),
  fallbackLocale: 'zh-TW',
  messages,
});

// 讓 Element UI 使用 VueI18n 的翻譯函式
ElementUI.i18n((key, value) => i18n.t(key, value));

export default i18n;
